import { render, staticRenderFns } from "./ClientCreatedWarning.vue?vue&type=template&id=6a1451e3&"
import script from "./ClientCreatedWarning.vue?vue&type=script&lang=ts&"
export * from "./ClientCreatedWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports